import styled from "styled-components";

import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { ButtonBase, DarkButton, LightButton } from "./Buttons";
import FormCheckbox from "./FormCheckbox";
import FormTextInput from "./FormTextInput";
import Modal, { Footer } from './Modal';
import Row from "./Row";
import { H1 } from "./Typography";
import { useDispatch } from 'react-redux';
import { setUserPassword } from "../common/slices/user";
import { toast } from "react-toastify";
import FormPasswordInput from "./FormPasswordInput";

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`

const ModalSetPassword = ({ onClose, user }) => {
    const dispatch = useDispatch();

    const {
        control,
        setError,
        formState: { errors, isSubmitting, isValid, isDirty },
        handleSubmit,
    } = useForm({
        defaultValues: {
            username: user?.email,
        }
    })
    const fieldProps = { control, errors };

    const onSaveClick = async (values) => {
        try {
            await dispatch(setUserPassword(values));
            onClose();
        } catch (ex) {
            setError('password', { message: ex.message });
        }
    }

    return (
        <Modal show onClose={() => !isDirty && onClose()} zindex="1300" size="40%">
            <Row>
                <H1>Set User Password</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>
            <form onSubmit={handleSubmit}>
                <FormPasswordInput {...fieldProps} name="password" placeholder="New Password" label="New Password" rules={{ required: true }} />
                <FormCheckbox {...fieldProps} name="permanent" placeholder="Permanently set password?" type="checkbox" />
                <p>If you do not permanently set the password, the user will be emailed this password and requested that they change it on their next login.</p>
            </form>
            <Footer>
                <DarkButton onClick={handleSubmit(onSaveClick)} disabled={isSubmitting || !isValid}>Set Password</DarkButton>
                <LightButton onClick={onClose}>Cancel</LightButton>
            </Footer>
        </Modal>
    )
}

export default ModalSetPassword